import LocationAdapter from 'shared/location_adapter';
import AhoyTracker from 'shared/ahoy_tracker';
import $ from "jquery"

export default class WatchSessionLimiter {
  static get interval() {
    return (Number(window.watchSessionLimiterInterval) || 60) * 1000;
  }

  static startHeartbeat(id) {
    WatchSessionLimiter.heartbeat(id);

    setInterval(function () {
      WatchSessionLimiter.heartbeat(id);
    }, WatchSessionLimiter.interval);
  }

  static heartbeat(id) {
    const headers = window.watchHe != undefined ? { 'X-Watch-He' : window.watchHe } : {}

    $.ajax({
      url: "/live/"+id+"/post_stream",
      dataType: "json",
      method: "POST",
      error: this.onError,
      headers: headers
    });
  }

  static onError(xhr) {
    WatchSessionLimiter.heartbeatError(xhr?.status);
  }

  static heartbeatError(status_code) {
    if(status_code == 401){
      LocationAdapter.href('/');
    }
  }

  static showBanner(errorMessage) {
    var sessionLimitBanner = document.querySelector('.session-limit-blocker');

    if(sessionLimitBanner) {
      this.sendBannerImpression(sessionLimitBanner);
      sessionLimitBanner.classList.remove('hide');

      var errorDescription = document.querySelector('.b-session-limit-blocker__main-description')
      if(errorDescription) {
        errorDescription.innerText = errorMessage;
      }

      var mobileErrorDescription = document.querySelector('.b-session-limit-blocker__description')
      if(mobileErrorDescription) {
        mobileErrorDescription.innerText = errorMessage;
      }
    }
  }

  static setBackgroundBlocker() {
    var banner = document.querySelector(".b-session-limit-blocker");
    var player = document.querySelector(".player-data");

    if(banner !== null && player !== null) {
      var videoImageUrl = player.getAttribute("data-video-image-url");

      banner.style.backgroundImage = "url(\"" + videoImageUrl + "\")";
      banner.classList.add("b-session-limit-blocker--image-enabled");
    }
  }

  static sendBannerImpression(element) {
    if(typeof(element) != 'undefined'){
      var ahoyTracker = new AhoyTracker(element);

      window.dataLayer.push({
        event: 'impression',
        feature_name: element.dataset.gtmName,
        feature_location: element.dataset.gtmLoc,
        feature_type: element.dataset.gtmType
      });
      ahoyTracker.sendEvent();
    }
  }
}
